import styled from 'styled-components'
import { device } from './breakpoints'

const ChartAxisText = styled.text`
  font-size: 0.75em;
  fill: #6e7087;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.75em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 0.75em;
  }
`

const ChartAxisTextColored = styled(ChartAxisText)`
  fill: ${({ theme }) => theme.brandColor};
  font-size: 0.75em;
  font-weight: 900;
`

const ChartAnnotations = styled.div`
  margin-bottom: 4rem;
`

const ChartNotes = styled.div`
  margin-top: 1rem;
  opacity: 0.5;
  font-size: 0.65em;
  line-height: 1.2;
`

const ChartTitle = styled.div`
  font-size: 1.1em;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
`

const ChartDescription = styled.div`
  line-height: 1.2;
  opacity: 0.65;
  font-size: 0.875em;
`

const ChartNote = styled.text`
  // paint-order: stroke;
  // stroke: var(--site-background);
  // stroke-width: 16;
  // stroke-linecap: butt;
  // stroke-linejoin: round;
  font-size: 0.875em;
  fill: var(--text-color);
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.75em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 0.875em;
  }
`

const Strong = styled.strong<{colored?: Boolean}>`
  color: ${({colored}) => colored ? ({ theme }) => theme.brandColor : 'var(--text-color)'};
  font-weight: 900;
  -webkit-font-smoothing: auto;
`

const ScrollytellingStepContent = styled.div<{opaque?: boolean, wide?: boolean, small?: boolean}>`
  font-family: var(--font-sans-serif);
  width: calc(100% - 2em);
  padding: 0 1em;
  line-height: 1.4;
  margin-bottom: calc(60vh - 2em);
  background: ${({opaque}) => opaque ? 'var(--site-background)' : 'transparent'};
  text-shadow: 0 0 10px var(--site-background);
  font-size: ${({small}) => small ? '1em' : '1.25em'};
  -webkit-font-smoothing: antialiased;

  &:last-child {
    margin-bottom: calc(100vh - 2em);
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    max-width: auto;
    font-size: ${({small}) => small ? '1em' : '1.2em'};
  }

  @media ${device.tablet}, @media ${device.laptop} {
    max-width: ${({wide}) => wide ? '700px' : '500px'};
    font-size: ${({small}) => small ? '1em' : '1.25em'};
  }
`

export {
  ChartAxisText,
  ChartAxisTextColored,
  ChartAnnotations,
  ChartNotes,
  ChartTitle,
  ChartDescription,
  ChartNote,
  Strong,
  ScrollytellingStepContent
}
